import { mqttConfig } from '@t-soft-io/retail-shared/platform'
import { GlobalConfig } from '../types'

export const GLOBAL_CONFIG: GlobalConfig = {
  API_BASE_URL: 'https://api.prod.t-soft.io/api/v2',
  ...mqttConfig('prod')
}
